import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistor, store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';

// 注意，开发期把 ResizeObserver 的回调推到下一帧，消掉 ResizeObserver loop 那条警告。
// 它由 FlexLayout 与日志列表同帧互相触发尺寸变化引起，CRA 的错误覆盖层却当成运行时错误弹出来。
// 覆盖层的 window error 监听在入口就注册好、又没有过滤回调，拦不住，只能让它别发生。
// 代价是布局测量晚一帧，生产不开这条。
if (process.env.NODE_ENV === 'development') {
  const NativeResizeObserver = window.ResizeObserver;
  if (NativeResizeObserver) {
    window.ResizeObserver = class extends NativeResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
  }
}

const container = document.getElementById('root')!;
const root = createRoot(container);


// // 严格模式暂时关闭
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>
// );

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
